import { render, staticRenderFns } from "./IconXOutline.vue?vue&type=template&id=f7983bb8"
import script from "./IconXOutline.vue?vue&type=script&lang=js"
export * from "./IconXOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports